// extracted by mini-css-extract-plugin
export var bookingsForm = "Form-module--bookingsForm--1a7yl";
export var inputGroup = "Form-module--inputGroup--3NkxP";
export var optionGroup = "Form-module--optionGroup--2x9lQ";
export var label = "Form-module--label--3DJ4k";
export var option = "Form-module--option--1fjBK";
export var unselected = "Form-module--unselected--1qQrW";
export var selected = "Form-module--selected--QnFj_";
export var invisibleTextarea = "Form-module--invisibleTextarea--1G4HH";
export var visibleTextarea = "Form-module--visibleTextarea--c8w-G";
export var bookingsFrom = "Form-module--bookingsFrom--3GUG4";
export var formSent = "Form-module--formSent--3n_9e";
export var bottomSection = "Form-module--bottomSection--2XluU";
export var formFailed = "Form-module--formFailed--rPfTe";
export var marketingSection = "Form-module--marketingSection--2BLYV";
export var marketingLabel = "Form-module--marketingLabel--2ICD5";